export default "__VITE_ASSET__BPyr87_i__"